<template>
  <div>
    <div v-if="!numero">
      <body class="font-sans text-gray-700">
        <div class="container mx-auto p-8 flex">
          <div class="max-w-md w-full mx-auto">
            <div class="bg-white rounded-lg shadow-2xl">
              <div class="p-8">
                <!--<a href=".">-->
                <h1 class="text-4xl text-center mb-12 font-thin">
                  Inicia sesión nuevamente
                </h1>

                <a href=".">
                  <button
                    class="
                      w-full
                      p-3
                      font-bold
                      text-xl
                      hover:bg-blue-400
                      mt-1
                      bg-blue-600
                      text-white
                      rounded
                      shadow
                    "
                  >
                    Entrar
                  </button>
                </a>
              </div>

              <div
                class="
                  flex
                  justify-between
                  p-8
                  text-sm
                  border-t border-gray-300
                  bg-gray-100
                "
              ></div>
            </div>
          </div>
        </div>
      </body>
    </div>
    <div v-if="numero" class="md:px-32">
      <div class="box-content mx-32 mt-2 font-bold">
        <p
          class="
            text-blue-400
            uppercase
            shadow-xl
            rounded
            text-center
            mt-2
            bg-white
            w-auto
            p-5
          "
        >
          AdministraciÓn de Pedidos
        </p>
      </div>
      <div class="border mt-5 rounded bg-white">
        <div class="bg-gray-100 grid justify-items-start"></div>

        <div
          class="
            border
            bg-gradient-to-l
            from-blue-800
            to-blue-400
            mt-3
            mb-2
            mx-10
            rounded
            flex
            inline
          "
        >
          <label class="m-5 font-bold uppercase text-white" for="start1"
            >Fecha inicial:</label
          >

          <input
            @keypress.enter="loadfechas()"
            v-model="dia"
            class="today h-8 mt-5 border border-black rounded"
            type="date"
            id="dia"
            min="2021-03-06"
          />

          <label class="m-5 font-bold uppercase text-white" for="start"
            >Fecha final:</label
          >

          <input
            @keypress.enter="loadfechas()"
            v-model="dia2"
            class="h-8 mt-5 border border-black rounded"
            type="date"
            id="start"
            name="trip-start"
            min="2021-05-06"
            defa
          />
          <button
            @click="loadfechas()"
            class="
              bg-gradient-to-l
              from-blue-500
              to-blue-400
              h-10
              w-10
              col-start-1
              mt-4
              hover:bg-blue-400
              border border-blue-100
              flex
              rounded
              justify-end
              p-1
              m-3
            "
          >
            <!-- <img
            
              src="../assets/recargar.png"
              width="30px"
              height="30px"
              alt=""
            /> -->
            <i class="fa fa-refresh w-10 fa-2x"></i>
          </button>
          <div class="flex">
            <button
              @click="cambio3(), cambio2()"
              class="
                h-10
                col-start-2
                font-bold
                text-white
                col-start-1
                mt-4
                border border-green-600
                flex
                rounded
                justify-end
                p-2
                m-3
                bg-gradient-to-l
                from-green-300
                to-green-400
              "
            >
              Pedidos Pendientes
            </button>
          </div>
        </div>
        <div>
          <tablaPedidos v-if="mostrar"></tablaPedidos>
          <!--<h1 v-if="!mostrar" class="font-bold border shadow text-center bg-red-400 ">{{ mensajes }}</h1>-->
          <modalDetalle v-if="mostrar"></modalDetalle>
          <modaldatostransportista></modaldatostransportista>
          <notifications class="font-bold" position="bottom left" group="foo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import tablaPedidos from "../components/Tablas/tablaPedidos.vue";
import modalDetalle from "../components/modales/modalDetalle.vue";
import modaldatostransportista from "../components/modales/modaldatostransportista.vue";

export default {
  components: { tablaPedidos, modalDetalle, modaldatostransportista },
  name: "pedidos",
  data() {
    return {
      mostrardato: true,
      dia: [],
      dia2: "",
      mostrar: false,
      mensajes: "",
    };
  },
  mounted() {
    (this.dia = new Date().toISOString().substr(0, 10)), // 05/09/2019,
      (this.dia2 = new Date().toISOString().substr(0, 10)); // 05/09/2019,
    //  this.dia = this.dia.defaultValue = "2021-05-06";
  },
  methods: {
    ...mapMutations("pedidos", ["cargardatospendientes", "cargardatosfecha"]),

    async loadfechas() {
      var data = {
        data1: this.dia,
        data2: this.dia2,
      };
      this.cargardatosfecha(data);
      setTimeout(() => {
        this.cambio();
      }, 50);
    },

    cambio3() {
      this.cargardatospendientes();
      setTimeout(() => {
        if (this.len2 == true) {
          this.mostrar = false;
           this.$notify({
          group: "foo",
          title: "MENSAJE IMPORTANTE",
          text: "Sin pedidos Pendientes!",
        });
        } else {
          this.mostrar = true;
        }
      }, 50);
    },

    cambio2() {
      if (!this.mostrar) {
        this.mostrar = !this.mostrar;

        /*if (this.len2) {
        
          this.mostrar = false;
        }*/
      }
    },
    cambio() {
      if (this.len === 0) {
        this.mostrar = false;
        // this.mensajes = "Sin Pedidos En rango de fechas";
        this.$notify({
          group: "foo",
          title: "MENSAJE IMPORTANTE",
          text: "SIN PEDIDOS EN EL RANGO DE FECHAS SELECCIONADO!",
        });
      } else {
        this.mostrar = false;
      }
      if (this.len > 0) {
        this.mostrar = true;
        this.mensajes = "";
      }

      if (this.dia === []) {
        this.mostrar = false;
        this.$notify({
          group: "foo",
          title: "Mensaje Importante",
          text: "Por favor llene ambas fechas Correctamente!",
        });
      }
    },
    /*
    var objFecha = new Date();
    var dia = objFecha.getDate();
    var mes = objFecha.getMonth() + 1;
    var anio = objFecha.getFullYear();
    if (dia < 10) {
      this.dia = anio + "-" + mes + "-" + 0 + dia;
      this.dia2 = anio + "-" + mes + "-" + 0 + dia;
      if (mes < 10) {
        this.dia = anio + "-" + 0 + mes + "-" + 0 + dia;
        this.dia2 = anio + "-" + 0 + mes + "-" + 0 + dia;
       
      }
    } else {
      if (mes < 10) {
        this.dia = anio + "-" + 0 + mes + "-" + dia;
        this.dia2 = anio + "-" + 0 + mes + "-" + dia;
     
      } else {
        this.dia = anio + "-" + mes + "-" + dia;
        this.dia2 = anio + "-" + mes + "-" + dia;
    s
    },
      }*/
  },

  computed: {
    ...mapState(["numero"]),
    ...mapState("pedidos", ["pedido", "bandera", "len2", "len"]),
  },
};
</script>
<style scoped>
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: auto;

  margin: auto;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modaldetalle:target {
  opacity: 1;
  pointer-events: auto;
}
</style>